import * as TypeGraphQL from "type-graphql";
export var ConfigType;
(function (ConfigType) {
    ConfigType["ANALYTICS"] = "ANALYTICS";
    ConfigType["RISK_MANAGEMENT"] = "RISK_MANAGEMENT";
    ConfigType["TRADING"] = "TRADING";
    ConfigType["SYSTEM"] = "SYSTEM";
    ConfigType["USER_PREFERENCE"] = "USER_PREFERENCE";
})(ConfigType || (ConfigType = {}));
TypeGraphQL.registerEnumType(ConfigType, {
    name: "ConfigType",
    description: undefined,
});
//# sourceMappingURL=ConfigType.js.map